import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const RltdCntntItem2 = styled.div`
  position: relative;
  width: 100%;

  .btn {
    display: block;
    width: 100%;
    text-align: left;

    .img {
      padding-bottom: 113.46153846%;
    }

    .area-info {
      padding-top: 12px;

      .desc {
        height: 36px;
      }

      .title + .desc {
        margin-top: 2px;
      }
    }
  }

  .basic-btn {
    margin-top: 15px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      .area-info {
        padding-top: ${mixin.pxToVw('12')};

        .desc {
          height: ${mixin.pxToVw('36')};
        }

        .title + .desc {
          margin-top: ${mixin.pxToVw('2')};
        }
      }
    }

    .basic-btn {
      margin-top: ${mixin.pxToVw('15')};
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    .btn {
      .img {
        padding-bottom: 119.92031873%;
      }

      .area-info {
        height: 87px;
        padding-top: 10px;

        .title {
          font-size: 20px;

          + .desc {
            margin-top: 4px;
          }
        }

        .desc {
          height: 42px;
          font-size: 16px;
        }
      }
    }

    .basic-btn {
      .text {
        font-size: 14px;
      }
    }
  }
`;
